import React, { useContext } from "react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import SwitchTitleDescription from "../common/SwitchTitleDescription";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";

interface PieLabelConfigProps {}

const labelTypes = [
  { value: "percentage", label: "Percentage (34.2%)" },
  { value: "value", label: "Value (150)" },
  { value: "both", label: "Both (34.2% - 150)" },
  { value: "name", label: "Name (New)" },
] as const;

const PieLabelConfig: React.FC<PieLabelConfigProps> = ({}) => {
  const { config, setConfig } = useContext(GraphConfigFormContext);

  if (!config) return null;

  // Default pieLabels config for backward compatibility
  const pieLabels = config.graph_options.pieLabels || { show: true, type: "percentage" as const };

  const onChange = (updatedPieLabels: typeof pieLabels) => {
    setConfig({
      ...config,
      graph_options: {
        ...config.graph_options,
        pieLabels: updatedPieLabels,
      },
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <SwitchTitleDescription
        title="Show Labels on Slices"
        description="Display labels directly on pie/donut chart slices"
        value={pieLabels.show}
        onChange={(checked: boolean) => onChange({ ...pieLabels, show: checked })}
      />
      
      {pieLabels.show && (
        <div className="flex flex-row items-center justify-between w-full gap-1">
          <Label>Label Format</Label>
          <Select
            value={pieLabels.type}
            onValueChange={(value) =>
              onChange({ ...pieLabels, type: value as typeof pieLabels.type })
            }
          >
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Select format" />
            </SelectTrigger>
            <SelectContent>
              {labelTypes.map((type) => (
                <SelectItem key={type.value} value={type.value}>
                  {type.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};

export default PieLabelConfig;
